export default {
    bind(el, binding) {
        let $wrapper = $(el)
        let options = binding.value || {}
        $wrapper.on('load', () => {
            let size = $wrapper[0].height > $wrapper[0].width ? $wrapper[0].width : $wrapper[0].height
            options.x2 = size
            options.y2 = size
            options.x1 = 0
            options.y1 = 0
            $wrapper.imgAreaSelect(options)
        })
    },
    unbind(el, binding) {
        let $wrapper = $(el)
        $wrapper.imgAreaSelect({
            remove: true,
        })
    }
}


// WEBPACK FOOTER //
// ./src/webpack/vue/components/crop.js